import { useCallback } from "react"
import { PropTypes } from "prop-types"

import useFastField from "../useFastField"
import DateField from "."

export default function DateFieldWrapper({ name, errorParams, ...rest }) {
  const { field, error, helpers, touched } = useFastField(name)
  const { setTouched, setValue } = helpers
  const onChange = useCallback((key, value) => setValue(value), [setValue])
  const onBlur = useCallback(() => setTouched(true), [setTouched])

  const customError = {
    ...error,
    params: errorParams
  }

  return (
    <DateField
      {...field}
      error={customError}
      onBlur={onBlur}
      onChange={onChange}
      touched={field.value ? touched : false}
      {...rest}
    />
  )
}

DateFieldWrapper.propTypes = {
  name: PropTypes.string.isRequired,
  errorParams: PropTypes.shape({ minAge: PropTypes.number, maxAge: PropTypes.number })
}
